import { render, staticRenderFns } from "./couponModal.vue?vue&type=template&id=3c1c5d3d&scoped=true"
import script from "./couponModal.vue?vue&type=script&lang=js"
export * from "./couponModal.vue?vue&type=script&lang=js"
import style0 from "./couponModal.vue?vue&type=style&index=0&id=3c1c5d3d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c5d3d",
  null
  
)

export default component.exports